import { render, staticRenderFns } from "./DurationStudy.vue?vue&type=template&id=29f9533e&scoped=true"
import script from "./DurationStudy.vue?vue&type=script&lang=js"
export * from "./DurationStudy.vue?vue&type=script&lang=js"
import style0 from "./DurationStudy.vue?vue&type=style&index=0&id=29f9533e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f9533e",
  null
  
)

export default component.exports